import { render, staticRenderFns } from "./Detail-Invoice.vue?vue&type=template&id=5282a6a2&scoped=true"
import script from "./Detail-Invoice.vue?vue&type=script&lang=js"
export * from "./Detail-Invoice.vue?vue&type=script&lang=js"
import style0 from "./Detail-Invoice.vue?vue&type=style&index=0&id=5282a6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282a6a2",
  null
  
)

export default component.exports